import { useAtom } from 'jotai'
import { useLocalStorage } from '~/hooks/useLocalStorage'
import { callPopStateAtom } from '~/pages/Settings/NotificationSettings'
import { isElectron } from '~/utils/common'

export const useCallPopEnabled = () => {
  const [callPopState] = useAtom(callPopStateAtom)
  const [callPopRaw] = useLocalStorage<{ callPopEnabled?: boolean }>({
    key: 'callPop',
    initialValue: {},
  })

  // Popup setting is only available in electron, so always return false in web
  if (!isElectron) {
    return false
  }

  return callPopState.callPopEnabled ?? callPopRaw?.callPopEnabled ?? false
}
